import styles from "../../styles/_containers/_clients/search.module.scss";

const Search = ({ search, setSearch }) => {
  return (
    <div className={styles.container}>
      <div className={styles.right}>
        <h2>רשימת לקוחות</h2>
        <p>חיפוש מהיר לפי שם או מספר טלפון</p>
      </div>
      <div className={styles.left}>
        <div className={styles.input}>
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="1.8" /><path d="m16 16 4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>
          <input
            type="text"
            placeholder="חיפוש לקוח..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            aria-label="חיפוש לקוח לפי שם או טלפון"
          />
          {search && (
            <button type="button" onClick={() => setSearch("")} aria-label="ניקוי החיפוש">×</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Search;
